export default __webpack_public_path__ + "media/ios.d7878138.svg";